import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

import SkuForm from "./components/ebayAuction/SkuForm";

const EbayAuctionLabelPage = () => {
  const [submitting, setSubmitting] = useState(false);
  const [sku, setSku] = useState("");

  return (
    <>
      <Helmet title="Auction Labels" />
      <h1 className="mb-3">Auction Labels</h1>
      <Container fluid className="p-0">
        <Row>
          <Col xl={{ span: 4, offset: 4 }}>
            <SkuForm
              submitting={submitting}
              setSubmitting={setSubmitting}
              sku={sku}
              setSku={setSku}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EbayAuctionLabelPage;
